import styled from "styled-components";
import {
  fontWeightBold,
  h3Regular,
} from "../../../../components/typography/MuiTypography.style";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const CreateProgramKeyInputWrapper = styled.div`
  background-color: ${COLORS.cirrus_white};
  .form-container {
    padding: 0px 0px 24px 16px;

    ${responsive.MOBILE`
      padding: 0px 8px 16px 8px;
    `}
  }

  .line-container {
    border-top: 1px dashed ${COLORS.primary_light_blue4};
    padding-bottom: 24px;
  }

  .tag-project-container {
    padding: 0 16px 24px;
  }

  .project-details-container {
    padding: 0px 0px 24px 16px;
    ${responsive.MOBILE`
      padding: 0px 8px 16px 8px;
    `}
    .grid-size-medium {
      &:nth-child(-n + 3) {
        margin-top: 0px;
      }
    }
  }

  .update-input-general {
    .MuiAccordionSummary-root,
    .MuiAccordion-heading {
      display: none;
    }
    .form-container {
      padding: 0px 0 24px 16px;
    }
  }

  .opportunity-id-container {
    position: relative;
  }

  .validate-link {
    ${h3Regular}
    ${fontWeightBold}
    position: absolute;
    top: 0px;
    text-decoration: underline;
    text-underline-offset: 4px;
    right: 0px;
    color: ${COLORS.primary_light_blue};
  }
`;
